/**
 * EmbedNotFound — what /forms/embed/<anything that is not a form> renders.
 *
 * WHY THIS EXISTS: every path under /forms/embed/ is served with the embed
 * headers, which let the public website frame the page. Before this page, a
 * path like /forms/embed/a/b fell through to the Forms module's '*' route,
 * which <Navigate>s to /forms IN PLACE — so the logged-in OfficeHub app
 * rendered inside a frame the website controls (and onpointgen.com is
 * same-site with app.onpointgen.com, so a staff session cookie rides along).
 *
 * THE RULE: this page is STATIC. It never navigates, never links into the
 * app, and reads no auth or org state. Keep it that way — anything rendered
 * here is frameable by the website.
 */
export default function EmbedNotFound() {
  return (
    <div role="alert" className="p-6 text-center text-sm text-slate-600">
      This form is not available.
    </div>
  );
}
